export const SHARE_BLACKBOOK_SEARCH_PARAM = 'share-blackbook'
